import React from "react";
import { IconProps } from "./IconProps";

const MagnifyingGlassPlusIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Thin":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          aria-label={ariaLabel}
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.7187 8.74996C11.7187 8.87428 11.6693 8.99351 11.5814 9.08142C11.4935 9.16933 11.3743 9.21871 11.25 9.21871H9.21871V11.25C9.21871 11.3743 9.16933 11.4935 9.08142 11.5814C8.99351 11.6693 8.87428 11.7187 8.74996 11.7187C8.62564 11.7187 8.50641 11.6693 8.41851 11.5814C8.3306 11.4935 8.28121 11.3743 8.28121 11.25V9.21871H6.24996C6.12564 9.21871 6.00641 9.16933 5.91851 9.08142C5.8306 8.99351 5.78121 8.87428 5.78121 8.74996C5.78121 8.62564 5.8306 8.50641 5.91851 8.41851C6.00641 8.3306 6.12564 8.28121 6.24996 8.28121H8.28121V6.24996C8.28121 6.12564 8.3306 6.00641 8.41851 5.91851C8.50641 5.8306 8.62564 5.78121 8.74996 5.78121C8.87428 5.78121 8.99351 5.8306 9.08142 5.91851C9.16933 6.00641 9.21871 6.12564 9.21871 6.24996V8.28121H11.25C11.3743 8.28121 11.4935 8.3306 11.5814 8.41851C11.6693 8.50641 11.7187 8.62564 11.7187 8.74996ZM17.8312 17.8312C17.7433 17.919 17.6242 17.9683 17.5 17.9683C17.3757 17.9683 17.2566 17.919 17.1687 17.8312L13.1547 13.8172C11.8383 14.9618 10.1289 15.5507 8.38682 15.4596C6.64474 15.3685 5.00609 14.6046 3.81628 13.3288C2.62647 12.0531 1.97846 10.3653 2.00883 8.62108C2.03921 6.87689 2.74561 5.21264 3.97912 3.97912C5.21264 2.74561 6.87689 2.03921 8.62108 2.00883C10.3653 1.97846 12.0531 2.62647 13.3288 3.81628C14.6046 5.00609 15.3685 6.64474 15.4596 8.38682C15.5507 10.1289 14.9618 11.8383 13.8172 13.1547L17.8312 17.1687C17.919 17.2566 17.9683 17.3757 17.9683 17.5C17.9683 17.6242 17.919 17.7433 17.8312 17.8312ZM8.74996 14.5312C9.89339 14.5312 11.0111 14.1921 11.9619 13.5569C12.9126 12.9216 13.6536 12.0187 14.0911 10.9624C14.5287 9.90597 14.6432 8.74355 14.4201 7.6221C14.1971 6.50064 13.6464 5.47052 12.8379 4.662C12.0294 3.85348 10.9993 3.30287 9.87783 3.0798C8.75638 2.85673 7.59396 2.97122 6.53757 3.40878C5.48119 3.84635 4.57828 4.58735 3.94303 5.53807C3.30778 6.48879 2.96871 7.60654 2.96871 8.74996C2.97057 10.2827 3.58027 11.7521 4.66406 12.8359C5.74785 13.9197 7.21725 14.5294 8.74996 14.5312Z"
            fill={color}
          />
        </svg>
      );

    default:
      return null;
  }
};

export default MagnifyingGlassPlusIcon;
